"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ECharCodes;

(function (ECharCodes) {
  ECharCodes[ECharCodes["Null"] = 0] = "Null";
  ECharCodes[ECharCodes["StartOfHeading"] = 1] = "StartOfHeading";
  ECharCodes[ECharCodes["StartOfText"] = 2] = "StartOfText";
  ECharCodes[ECharCodes["EndOfText"] = 3] = "EndOfText";
  ECharCodes[ECharCodes["EndOfTransmission"] = 4] = "EndOfTransmission";
  ECharCodes[ECharCodes["Enquiry"] = 5] = "Enquiry";
  ECharCodes[ECharCodes["Acknowledge"] = 6] = "Acknowledge";
  ECharCodes[ECharCodes["Bell"] = 7] = "Bell";
  ECharCodes[ECharCodes["Backspace"] = 8] = "Backspace";
  ECharCodes[ECharCodes["Tab"] = 9] = "Tab";
  ECharCodes[ECharCodes["LineFeed"] = 10] = "LineFeed";
  ECharCodes[ECharCodes["VerticalTab"] = 11] = "VerticalTab";
  ECharCodes[ECharCodes["FormFeed"] = 12] = "FormFeed";
  ECharCodes[ECharCodes["CarriageReturn"] = 13] = "CarriageReturn";
  ECharCodes[ECharCodes["ShiftOut"] = 14] = "ShiftOut";
  ECharCodes[ECharCodes["ShirtIn"] = 15] = "ShirtIn";
  ECharCodes[ECharCodes["DataLineEscape"] = 16] = "DataLineEscape";
  ECharCodes[ECharCodes["DeviceControl1"] = 17] = "DeviceControl1";
  ECharCodes[ECharCodes["DeviceControl2"] = 18] = "DeviceControl2";
  ECharCodes[ECharCodes["DeviceControl3"] = 19] = "DeviceControl3";
  ECharCodes[ECharCodes["DeviceControl4"] = 20] = "DeviceControl4";
  ECharCodes[ECharCodes["NegativeAcknowledgement"] = 21] = "NegativeAcknowledgement";
  ECharCodes[ECharCodes["SynchronousIdle"] = 22] = "SynchronousIdle";
  ECharCodes[ECharCodes["EndOfTransmitBlock"] = 23] = "EndOfTransmitBlock";
  ECharCodes[ECharCodes["Cancel"] = 24] = "Cancel";
  ECharCodes[ECharCodes["EndOfMedium"] = 25] = "EndOfMedium";
  ECharCodes[ECharCodes["Substitute"] = 26] = "Substitute";
  ECharCodes[ECharCodes["Escape"] = 27] = "Escape";
  ECharCodes[ECharCodes["FileSeparator"] = 28] = "FileSeparator";
  ECharCodes[ECharCodes["GroupSeparator"] = 29] = "GroupSeparator";
  ECharCodes[ECharCodes["RecordSeparator"] = 30] = "RecordSeparator";
  ECharCodes[ECharCodes["UnitSeparator"] = 31] = "UnitSeparator";
  ECharCodes[ECharCodes["Space"] = 32] = "Space";
  ECharCodes[ECharCodes["ExclamationMark"] = 33] = "ExclamationMark";
  ECharCodes[ECharCodes["DoubleQuote"] = 34] = "DoubleQuote";
  ECharCodes[ECharCodes["Hash"] = 35] = "Hash";
  ECharCodes[ECharCodes["$"] = 36] = "$";
  ECharCodes[ECharCodes["Percent"] = 37] = "Percent";
  ECharCodes[ECharCodes["Ampersand"] = 38] = "Ampersand";
  ECharCodes[ECharCodes["SingleQuote"] = 39] = "SingleQuote";
  ECharCodes[ECharCodes["OpenParenthesis"] = 40] = "OpenParenthesis";
  ECharCodes[ECharCodes["CloseParenthesis"] = 41] = "CloseParenthesis";
  ECharCodes[ECharCodes["Asterisk"] = 42] = "Asterisk";
  ECharCodes[ECharCodes["Plus"] = 43] = "Plus";
  ECharCodes[ECharCodes["Comma"] = 44] = "Comma";
  ECharCodes[ECharCodes["Hyphen"] = 45] = "Hyphen";
  ECharCodes[ECharCodes["Period"] = 46] = "Period";
  ECharCodes[ECharCodes["Slash"] = 47] = "Slash";
  ECharCodes[ECharCodes["_0"] = 48] = "_0";
  ECharCodes[ECharCodes["_1"] = 49] = "_1";
  ECharCodes[ECharCodes["_2"] = 50] = "_2";
  ECharCodes[ECharCodes["_3"] = 51] = "_3";
  ECharCodes[ECharCodes["_4"] = 52] = "_4";
  ECharCodes[ECharCodes["_5"] = 53] = "_5";
  ECharCodes[ECharCodes["_6"] = 54] = "_6";
  ECharCodes[ECharCodes["_7"] = 55] = "_7";
  ECharCodes[ECharCodes["_8"] = 56] = "_8";
  ECharCodes[ECharCodes["_9"] = 57] = "_9";
  ECharCodes[ECharCodes["Colon"] = 58] = "Colon";
  ECharCodes[ECharCodes["Semicolon"] = 59] = "Semicolon";
  ECharCodes[ECharCodes["Less"] = 60] = "Less";
  ECharCodes[ECharCodes["Equal"] = 61] = "Equal";
  ECharCodes[ECharCodes["Greater"] = 62] = "Greater";
  ECharCodes[ECharCodes["QuestionMark"] = 63] = "QuestionMark";
  ECharCodes[ECharCodes["At"] = 64] = "At";
  ECharCodes[ECharCodes["A"] = 65] = "A";
  ECharCodes[ECharCodes["B"] = 66] = "B";
  ECharCodes[ECharCodes["C"] = 67] = "C";
  ECharCodes[ECharCodes["D"] = 68] = "D";
  ECharCodes[ECharCodes["E"] = 69] = "E";
  ECharCodes[ECharCodes["F"] = 70] = "F";
  ECharCodes[ECharCodes["G"] = 71] = "G";
  ECharCodes[ECharCodes["H"] = 72] = "H";
  ECharCodes[ECharCodes["I"] = 73] = "I";
  ECharCodes[ECharCodes["J"] = 74] = "J";
  ECharCodes[ECharCodes["K"] = 75] = "K";
  ECharCodes[ECharCodes["L"] = 76] = "L";
  ECharCodes[ECharCodes["M"] = 77] = "M";
  ECharCodes[ECharCodes["N"] = 78] = "N";
  ECharCodes[ECharCodes["O"] = 79] = "O";
  ECharCodes[ECharCodes["P"] = 80] = "P";
  ECharCodes[ECharCodes["Q"] = 81] = "Q";
  ECharCodes[ECharCodes["R"] = 82] = "R";
  ECharCodes[ECharCodes["S"] = 83] = "S";
  ECharCodes[ECharCodes["T"] = 84] = "T";
  ECharCodes[ECharCodes["U"] = 85] = "U";
  ECharCodes[ECharCodes["V"] = 86] = "V";
  ECharCodes[ECharCodes["W"] = 87] = "W";
  ECharCodes[ECharCodes["X"] = 88] = "X";
  ECharCodes[ECharCodes["Y"] = 89] = "Y";
  ECharCodes[ECharCodes["Z"] = 90] = "Z";
  ECharCodes[ECharCodes["OpenBracket"] = 91] = "OpenBracket";
  ECharCodes[ECharCodes["Backslash"] = 92] = "Backslash";
  ECharCodes[ECharCodes["CloseBracket"] = 93] = "CloseBracket";
  ECharCodes[ECharCodes["Caret"] = 94] = "Caret";
  ECharCodes[ECharCodes["Underscore"] = 95] = "Underscore";
  ECharCodes[ECharCodes["Backtick"] = 96] = "Backtick";
  ECharCodes[ECharCodes["a"] = 97] = "a";
  ECharCodes[ECharCodes["b"] = 98] = "b";
  ECharCodes[ECharCodes["c"] = 99] = "c";
  ECharCodes[ECharCodes["d"] = 100] = "d";
  ECharCodes[ECharCodes["e"] = 101] = "e";
  ECharCodes[ECharCodes["f"] = 102] = "f";
  ECharCodes[ECharCodes["g"] = 103] = "g";
  ECharCodes[ECharCodes["h"] = 104] = "h";
  ECharCodes[ECharCodes["i"] = 105] = "i";
  ECharCodes[ECharCodes["j"] = 106] = "j";
  ECharCodes[ECharCodes["k"] = 107] = "k";
  ECharCodes[ECharCodes["l"] = 108] = "l";
  ECharCodes[ECharCodes["m"] = 109] = "m";
  ECharCodes[ECharCodes["n"] = 110] = "n";
  ECharCodes[ECharCodes["o"] = 111] = "o";
  ECharCodes[ECharCodes["p"] = 112] = "p";
  ECharCodes[ECharCodes["q"] = 113] = "q";
  ECharCodes[ECharCodes["r"] = 114] = "r";
  ECharCodes[ECharCodes["s"] = 115] = "s";
  ECharCodes[ECharCodes["t"] = 116] = "t";
  ECharCodes[ECharCodes["u"] = 117] = "u";
  ECharCodes[ECharCodes["v"] = 118] = "v";
  ECharCodes[ECharCodes["w"] = 119] = "w";
  ECharCodes[ECharCodes["x"] = 120] = "x";
  ECharCodes[ECharCodes["y"] = 121] = "y";
  ECharCodes[ECharCodes["z"] = 122] = "z";
  ECharCodes[ECharCodes["OpenBrace"] = 123] = "OpenBrace";
  ECharCodes[ECharCodes["Bar"] = 124] = "Bar";
  ECharCodes[ECharCodes["CloseBrace"] = 125] = "CloseBrace";
  ECharCodes[ECharCodes["Tilde"] = 126] = "Tilde";
  ECharCodes[ECharCodes["Delete"] = 127] = "Delete";
  ECharCodes[ECharCodes["NonBreakingSpace"] = 160] = "NonBreakingSpace";
  ECharCodes[ECharCodes["EnQuad"] = 8192] = "EnQuad";
  ECharCodes[ECharCodes["EmQuad"] = 8193] = "EmQuad";
  ECharCodes[ECharCodes["EnSpace"] = 8194] = "EnSpace";
  ECharCodes[ECharCodes["EmSpace"] = 8195] = "EmSpace";
  ECharCodes[ECharCodes["ThreePerEmSpace"] = 8196] = "ThreePerEmSpace";
  ECharCodes[ECharCodes["FourPerEmSpace"] = 8197] = "FourPerEmSpace";
  ECharCodes[ECharCodes["SixPerEmSpace"] = 8198] = "SixPerEmSpace";
  ECharCodes[ECharCodes["FigureSpace"] = 8199] = "FigureSpace";
  ECharCodes[ECharCodes["PunctuationSpace"] = 8200] = "PunctuationSpace";
  ECharCodes[ECharCodes["ThinSpace"] = 8201] = "ThinSpace";
  ECharCodes[ECharCodes["HairSpace"] = 8202] = "HairSpace";
  ECharCodes[ECharCodes["ZeroWidthSpace"] = 8203] = "ZeroWidthSpace";
  ECharCodes[ECharCodes["NarrowNoBreakSpace"] = 8239] = "NarrowNoBreakSpace";
  ECharCodes[ECharCodes["IdeographicSpace"] = 12288] = "IdeographicSpace";
  ECharCodes[ECharCodes["MathematicalSpace"] = 8287] = "MathematicalSpace";
  ECharCodes[ECharCodes["Ogham"] = 5760] = "Ogham";
})(ECharCodes || (ECharCodes = {}));

exports.default = ECharCodes;